import {AnyAction, Dispatch,bindActionCreators} from 'redux';
import {ConnectedProps, connect} from 'react-redux';
import { WithRouterProps, withRouter } from '../../../../common/WithRouter';
import {getAllSuppliers} from '../../../../actions/supplierActions';
import {getIncompleteTimesheets} from '../../../../actions/timesheetActions';
import {getPermissions, getUser, getVisibleUsers, loginAdfsUser, loginUser, resetPassword } from '../../../../actions/userActions';
import {getReleaseNotes} from '../../../../actions/releaseNotesActions';
import { queryString } from '../../../../esm';
import {updateSetting} from '../../../../actions/settingsActions';
import ComponentHelper from '../../../../helpers/componentHelper';
import LoginModal from './LoginModal';
import React from 'react';

import {MappedUserCredentials, UserCredentials} from '../../../../typescript/userTypes';

import { LocationTypes } from '../../../../types/locationTypes';
import {StoreCalls, StoreState, StoreUser} from '../../../../typescript/storeTypes';
import WindowHelper from '../../../../helpers/windowHelper';

export class Login extends React.Component<Props, State> {
    state: State = {
        calls: this.props.calls,
        user: this.props.user,
        credentials: {
            username: localStorage.getItem('login_Username') === null ? '' : (localStorage.getItem('login_Username') as any),
            password: ''
        },
        credentialsErrors: ComponentHelper.createStateErrorsObject({
            username: '',
            password: ''
        })
    };

    onChange = (event: React.SyntheticEvent<HTMLInputElement> & { currentTarget: HTMLInputElement }): void => {
        if (!this.props.calls.loginRequested) {
            const credentials = Object.assign({}, this.state.credentials);
            (credentials as {[key: string]: any})[event.currentTarget.name] = event.currentTarget.value;
            return this.setState({credentials});
        }
    };

    onSubmit = (event: React.MouseEvent<HTMLInputElement, MouseEvent>): void => {
        event.preventDefault();

        if (!this.props.calls.loginRequested) {
            const errors = ComponentHelper.createStateErrorsObject(this.state.credentials);

            if (!this.state.credentials.username) errors.username = 'Please enter a username.';
            if (!this.state.credentials.password) errors.password = 'Please enter a password.';

            if (Object.keys(errors).find(key => errors[key])) {
                return this.setState({credentialsErrors: errors});
            } else {
                this.setState({credentialsErrors: errors});
            }

            this.props.loginUser(this.state.credentials);
        }
    };

    adfsReturnedCheck = () => {
        const windowLocation = WindowHelper.getWindowLocation();
        if(windowLocation.pathname.toLocaleLowerCase().endsWith(LocationTypes.ADFS_LOGIN.toLocaleLowerCase()) && !this.props.calls.loginRequested) {
            const item = queryString.parse(windowLocation.search);
            if(this.props.user.authenticatedUser.token === '' && item.code) {
                this.props.loginAdfsUser({
                    adfsToken: item.code as string,
                    clientId: process.env.WEBSITE_CLIENT_ID,
                    resource : 'http://localhost/TiaApiTest',
                    redirectUri: process.env.WEBSITE_REDIRECT_URI
                });
            } else {
                if(item.state) {
                    WindowHelper.setWindowLocation(item.state.toString());
                }
            }
        }
    };

    onComponentInit = (): void => {
        if (!this.props.calls.loginRequested && this.props.user.authenticatedUser.token && this.props.user.authenticatedUser.username !== '') {
            this.props.getUser(this.props.user.authenticatedUser.username);
            this.props.getPermissions();
            this.props.getVisibleUsers();
            this.props.getIncompleteTimesheets();
            this.getReleaseNotes();
            this.props.getAllSuppliers();
        }
    };

    getReleaseNotes = () => {
        if(this.props.settings.lastSeenReleaseNotes !== undefined) {
            const version = parseInt(process.env.BUILD_VERSION && process.env.BUILD_VERSION.replace(new RegExp('\\.','g'), ''));
            if (this.props.settings.lastSeenReleaseNotes < version) {
                this.props.getReleaseNotes();
            }
        } else {
            this.props.updateSetting('lastSeenReleaseNotes', 0);
        }
    };

    componentDidMount() {
        this.onComponentInit();
    }

    static getDerivedStateFromProps(nextProps: Props, prevState: State) {
        if (!nextProps.calls.loginRequested && prevState.calls.loginRequested) {
            if (nextProps.user.authenticatedUser.token !== '' && prevState.user.authenticatedUser.username)
            {
                return {credentials: {username: prevState.credentials.username, password: ''}};
            }
        }

        return null;
    }

    componentDidUpdate(prevProps: Props): void {
        if(this.props.user.authenticatedUser.token !== prevProps.user.authenticatedUser.token)
        {
            this.onComponentInit();
        }
    }

    render() {
        if(!this.props.user.authenticationError) {
            this.adfsReturnedCheck();
        }
        return this.props.user.authenticatedUser.token ? null : (
            <div className="login">
                <LoginModal credentials={this.state.credentials} credentialsErrors={this.state.credentialsErrors}
                            onChange={this.onChange} onSubmit={this.onSubmit}
                            authenticationError={this.props.user.authenticationError}
                            updateSetting={this.props.updateSetting}
                            resetPassword={this.props.resetPassword} />
            </div>
        );
    }
}


const connector = connect(mapStateToProps, mapDispatchToProps);

type MappedProps = ConnectedProps<typeof connector>;

type Props = MappedProps;

type State = {
    calls: StoreCalls,
    user: StoreUser,
    credentials: UserCredentials,
    credentialsErrors: MappedUserCredentials
};

function mapStateToProps(state: StoreState, props: WithRouterProps) {
    return {
        user: state.user,
        calls: state.calls,
        settings: state.settings,
        releaseNotes: state.releaseNotes,
        location: props.location, // routed
        navigate: props.navigate, // routed
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({
        loginUser,
        loginAdfsUser,
        getUser,
        getPermissions,
        getVisibleUsers,
        updateSetting,
        getReleaseNotes,
        getIncompleteTimesheets,
        getAllSuppliers,
        resetPassword
    }, dispatch);
}

export default withRouter(connector(Login));
